var checkboxOnChangeFunctions = [];

naja.addEventListener('success', (e) => {

    if (!_.isNull(ID['map'])) {
        localStorage.setItem('shipping-key', e.detail.payload.apiKey);

        if (localStorage.getItem('shipping-key') === 'ZFNpsQ2C9jqH3zhhJldlitbfZBNzmn9ACy3VZLvlCgw') {
            console.log('Je použito testovací API KEY pro mapy.cz');

        }

        let map;
        let mapEl = ID['map'];

        if (!mapEl.initLeaflet) {
            // Načítání uložené pozice z localStorage
            const savedBranchId = localStorage.getItem('selectedBranchId');
            const savedLat = parseFloat(localStorage.getItem('selectedLat'));
            const savedLng = parseFloat(localStorage.getItem('selectedLng'));

            // Pokud máme uloženy souřadnice a branchId, nastavíme mapu na tuto pozici
            if (savedBranchId && !isNaN(savedLat) && !isNaN(savedLng)) {
                map = L.map('map').setView([savedLat, savedLng], 17);  // Nastavení pozice na uloženou lokaci
            } else {
                // Pokud není uložena žádná pozice, nastavíme výchozí pozici
                map = L.map('map').setView([50.08804, 14.42076], 13);  // Praha jako výchozí pozice
            }

            // Přidání Mapy.cz dlaždic
            L.tileLayer('https://api.mapy.cz/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=' + localStorage.getItem('shipping-key'), {
                maxZoom: 18
            }).addTo(map);

            const LogoControl = L.Control.extend({
                options: {
                    position: 'bottomleft',
                },
                onAdd: function (map) {
                    const container = L.DomUtil.create('div');
                    const link = L.DomUtil.create('a', '', container);

                    link.setAttribute('href', 'http://mapy.cz/');
                    link.setAttribute('target', '_blank');
                    link.innerHTML = '<img src="https://api.mapy.cz/img/api/logo.svg" />';
                    L.DomEvent.disableClickPropagation(link);

                    return container;
                },
            });

            // finally we add our LogoControl to the map
            new LogoControl().addTo(map);



            mapEl.initLeaflet = true;
            mapEl.objectLeaflet = map;

            // vytovření markerů
            const markers = L.markerClusterGroup().addTo(map);

            markers.name = 'branches';


        } else {
            map = mapEl.objectLeaflet;

        }

        map.on('load', () => {

            const markers = Object.values(map._layers).find(layer => layer.name === 'branches');

            if (markers.clearLayers) {
                markers.clearLayers();
            } else {
                console.error("Tato vrstva nemá metodu clearLayers.");
            }

            if (e.detail.payload.branches && e.detail.payload.branches != '') {
                const branches = JSON.parse(e.detail.payload.branches);

                Object.values(branches).forEach((branch, key) => {
                    var marker = L.marker([branch.latitude, branch.longitude], {
                        icon: L.icon({
                            iconUrl: '/assets/img/delivery/map/' + branch.type + '-icon.png',
                            iconSize: [38, 38]
                        }),
                        title: branch.name || 'Pobočka' // Titulek pro marker
                    });

                    marker.branchId = branch.id;

                    marker.on('click', e => {

                        // Uložíme informace do localStorage
                        localStorage.setItem('selectedBranchId', e.target.branchId);
                        localStorage.setItem('selectedLat', e.latlng.lat);
                        localStorage.setItem('selectedLng', e.latlng.lng);

                        naja.makeRequest(
                            'POST',
                            document.location.pathname + '?do=shippingModal-getBranchData',
                            {
                                'shippingModal-branchId': e.target.branchId,
                                'shippingModal-latitude': e.latlng.lat,
                                'shippingModal-longitude': e.latlng.lng
                            },
                            {history: false}
                        )

                    })

                    markers.addLayer(marker);

                });

            }



        });

        map.whenReady(() => {
            map.fire('load');

        });

        setTimeout(function(){
            map.invalidateSize();
        }, 400);



        const API_KEY = localStorage.getItem('shipping-key');
        const inputElem = document.querySelector("#searchShipping");
        const autoCompleteJS = new autoComplete({
            selector: () => inputElem,
            searchEngine: (query, record) => `<mark>${record}</mark>`,
            data: {
                keys: ["value"],
                src: async(query) => {
                    try {
                        const fetchData = await fetch(`https://api.mapy.cz/v1/suggest?lang=cs&limit=5&type=regional&locality=cz&apikey=${API_KEY}&query=${query}`);
                        const jsonData = await fetchData.json();

                        return jsonData.items.map(item => ({
                            value: item.name,
                            data: item,
                        }));
                    } catch (exc) {
                        console.log(exc);

                        return [];
                    }
                },
                cache: false,
            },
            trigger: (query) => {
                return query.length >= 3;
            },
            resultItem: {
                element: (item, data) => {
                    const itemData = data.value.data;
                    const desc = document.createElement("div");

                    desc.style = "overflow: hidden; white-space: nowrap; text-overflow: ellipsis;";
                    desc.innerHTML = `${itemData.label}, ${itemData.location}`;
                    item.append(
                        desc,
                    );
                },
                highlight: true
            },
            resultsList: {
                element: (list, data) => {
                    list.style.maxHeight = "max-content";
                    list.style.overflow = "hidden";

                    if (!data.results.length) {
                        const message = document.createElement("div");

                        message.setAttribute("class", "no_result");
                        message.style = "padding: 5px";
                        message.innerHTML = `<span>${ID['searchShipping'].dataset.addressNotFound} "${data.query}"</span>`;
                        list.prepend(message);
                    } else {
                        const logoHolder = document.createElement("div");
                        const text = document.createElement("span");
                        const img = new Image();

                        logoHolder.style = "padding: 5px; display: flex; align-items: center; justify-content: end; gap: 5px; font-size: 12px;";
                        text.textContent = "Powered by";
                        img.src = "https://api.mapy.cz/img/api/logo-small.svg";
                        img.style = "width: 60px";
                        logoHolder.append(text, img);
                        list.append(logoHolder);
                    }
                },
                noResults: true,
            },
        });

        const markersPosition = [];

        inputElem.addEventListener("selection", event => {
            // "event.detail" carries the autoComplete.js "feedback" object
            const origData = event.detail.selection.value.data;

            map.setView([origData.position.lat, origData.position.lon], 13)

            if (!_.isUndefined(markersPosition[0])) {
                map.removeLayer(markersPosition[0].marker);
                markersPosition.splice(0,1)

            }

            const marker = L.marker([origData.position.lat, origData.position.lon], {
                icon: L.icon({
                    iconUrl: '/assets/img/delivery/map/position-icon.png',
                    iconSize: [38, 38]
                })
            }).addTo(map);

            markersPosition.push({
                marker: marker,
                name: 'actual-position'
            })

            map.invalidateSize();

            ID['map-accuracy-text'].classList.add('d-none');

            naja.makeRequest(
                'POST',
                document.location.pathname + '?do=shippingModal-getBranches',
                {
                    'shippingModal-latitude': origData.position.lat,
                    'shippingModal-longitude': origData.position.lon
                },
                {
                    history: false
                }
            )

            inputElem.value = origData.name;

        });

        // získání aktualní pozice
        ID['location-address'].addEventListener('click', () => {
            navigator.geolocation.getCurrentPosition((position) => {

                map.setView([position.coords.latitude, position.coords.longitude], 13)

                if (!_.isUndefined(markersPosition[0])) {
                    map.removeLayer(markersPosition[0].marker);
                    markersPosition.splice(0,1)

                }

                const marker = L.marker([position.coords.latitude, position.coords.longitude], {
                    icon: L.icon({
                        iconUrl: '/assets/img/delivery/map/position-icon.png',
                        iconSize: [38, 38]
                    })
                }).addTo(map);

                markersPosition.push({
                    marker: marker,
                    name: 'actual-position'
                })

                map.invalidateSize();
                ID['map-accuracy-text'].classList.remove('d-none');
                if (!_.isNull(position.coords.accuracy)) {
                    const accuracy = position.coords.accuracy;
                    ID['map-accuracy'].innerHTML = Math.round(accuracy) >= 1000
                        ? Math.round(accuracy / 1000) + ' km'
                        : Math.round(accuracy) + ' m';

                }

                naja.makeRequest(
                    'POST',
                    document.location.pathname + '?do=shippingModal-getBranches',
                    {
                        'shippingModal-latitude': position.coords.latitude,
                        'shippingModal-longitude': position.coords.longitude
                    },
                    {
                        history: false
                    }
                )

            }, (error) => {
                console.error(error);
            }, {
                timeout: 3000,
                maximumAge: 0
            });
        })

        const setShippingBranchElements = document.getElementsByClassName('set-shipping-branch');
        Array.from(setShippingBranchElements).forEach(element => {
            element.addEventListener('click', e => {
                const parentElement = e.target.closest('.set-shipping-branch');
                //FNC.shippingModal.selectBranch(parentElement.dataset.branchId, ID.shipping.dataset.parent, parentElement.dataset.link, parentElement.dataset.shippingId);
                naja.makeRequest(
                    'POST',
                    document.location.pathname + '?do=shippingModal-getBranchInfo',
                    {
                        'shippingModal-branchId': e.target.closest("[data-branch-id]").dataset.branchId
                    },
                    {
                        history: false
                    }
                ).then(r => {

                    Array.from(document.getElementsByClassName('info')).forEach(el => {
                        el.classList.add('d-none')
                    });

                    ID['shipping'].value = parentElement.dataset.shippingCode;
                    ID["shipping-branch"].value = r.data.id;
                    // info modálního dialogu
                    let selected = ID['selected-branch-' + r.shippingId];
                    if(selected) {
                        selected.classList.remove('d-none');
                        selected.querySelector('.title').innerHTML = r.data.address;
                    }

                    shippingPrice(document.location.pathname + '?do=shippingPrice');
                })


            })


        });

        const shippingPrice = (link) => {
            naja.makeRequest('POST', link, {
                shipping: ID.shipping.value,
                payment: ID.payment.value,
                branchId: ID['shipping-branch'].value,
                parentId: ID.shipping.dataset.parent
            }, {
                history: false
            }).then(r => {

                if (r.branchData && ID.shipping.dataset.parent) {
                    let selected = ID['selected-branch-' + ID.shipping.dataset.parent];
                    if(selected) {
                        selected.classList.remove('d-none');
                        selected.querySelector(".title").innerHTML = r.branchData.address;
                    }
                    let input = ID["selected-shipping-" + ID.shipping.dataset.parent];
                    input.checked = true;
                }

                const allowPayments = r.payments;
                if (!_.isUndefined(allowPayments)) {
                    const payments = document.querySelectorAll('.payments-wrapp input[type="radio"]');

                    payments.forEach(element => {
                        if (element.hasAttribute('disabled')) {
                            element.removeAttribute('disabled');
                        }
                        if (allowPayments.includes && !allowPayments.includes(element.value)) {
                            element.setAttribute('disabled', 'disabled');
                        }

                        if (r.poorExcuses[element.value]) {
                            element.nextElementSibling.querySelector(".payment-excuse").innerHTML = r.poorExcuses[element.value];
                        }
                    });

                }
            })
        }

        const checkbox = document.getElementsByClassName('shipping-branch');
        const firstCheckbox = document.getElementById('frm-shippingModal-shippingForm-shipping-0');

        Array.from(checkbox).forEach((element, index, array) => {
            const func = (e) => {
                const form = document.getElementById('frm-shippingModal-shippingForm');
                const checkedCheckboxes = Array.from(checkbox).filter(checkbox => checkbox.checked);
                const clickedCheckbox = e.target;

                // Pokud je zaškrtnutý první checkbox, odškrtnout všechny ostatní
                if (firstCheckbox === clickedCheckbox && clickedCheckbox.checked) {
                    Array.from(checkbox).forEach((checkboxElement) => {
                        if (checkboxElement !== firstCheckbox) {
                            checkboxElement.checked = false;
                        }
                    });
                }

                // Pokud je zaškrtnutý jiný checkbox než první, odškrtnout první
                if (clickedCheckbox !== firstCheckbox && clickedCheckbox.checked) {
                    firstCheckbox.checked = false;
                }

                // Pokud není žádný checkbox zaškrtnutý, zaškrtnout první
                if (checkedCheckboxes.length === 0) {
                    firstCheckbox.checked = true;
                }
                
                // Odeslání formuláře
                naja.uiHandler.submitForm(form);
            };
            element.removeEventListener('change', checkboxOnChangeFunctions[index] ?? func)
            checkboxOnChangeFunctions[index] = func;
            element.addEventListener('change', func);
        });

        document.getElementById('ajax-modal').addEventListener('hidden.bs.modal', () => {
            const branchIdInput = document.getElementById('shipping-branch');

            if (branchIdInput.value === '' || branchIdInput.value == 0) {
                document.querySelectorAll('.shipping input').forEach(input => {
                    input.checked = false;
                });
            }


            fetch(document.location.pathname + '?do=shippingModal-deleteBranchesCache', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}),
                cache: 'no-store'
            }).catch(error => console.error('Request failed:', error));
        });

    }

});